import React, { useState } from "react";
import CompanyLogo from "../img/home_logo.png";
import { useTranslation } from "react-i18next";
import Icon from "../components/ui/Icon";
import TermsOfUse from "../components/TermsOfUse";
import LanguageSelector from "../components/LanguageSelector";
import { LoginService } from "../services/loginService";
import {
  Box,
  Button,
  Container,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";

function LoginPage() {
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (e) => e.preventDefault();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    var loginService = new LoginService();
    await loginService
      .login(username, password)
      .then((response) => {
        if (response.status === 200 && response.data.functionId) {
          setIsSuccess(true);
        } else {
          setIsError(true);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsError(true);
      });

    setIsLoading(false);
  };

  return (
    <Container
      id="pageLogin"
      maxWidth={false}
      sx={{
        bgcolor: "primary.main",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      {isSuccess ? (
        <TermsOfUse />
      ) : (
        <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 500 }}>
          <Paper elevation={3} sx={{ p: 5 }}>
            <img src={CompanyLogo} alt="" className="mb-2" id="companyLogo" style={{ width:"60%", margin:"0px auto" }}/>
            <Typography variant="h6" align="center" color="text.secondary" style={{ fontSize:"1.5rem" }}>
              {t("system.appName")}
            </Typography>
            <TextField
              error={isError}
              type="text"
              id="username"
              label={t("loginPage.username")}
              variant="filled"
              margin="normal"
              fullWidth
              onChange={(e) => setUsername(e.target.value)}
            />

            <TextField
              error={isError}
              type={showPassword ? "text" : "password"}
              id="password"
              label={t("loginPage.password")}
              variant="filled"
              margin="normal"
              fullWidth
              onChange={(e) => setPassword(e.target.value)}
              helperText={isError ? t("errors.loginError") : null}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end">
                      {showPassword ? (
                        <Icon src="visibility" color="currentColor" />
                      ) : (
                        <Icon src="visibilityOff" color="currentColor" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={isLoading}
              sx={{ my: 2 }}>
              {isLoading ? t("loginPage.loading") : t("loginPage.login")}
            </Button>

            <LanguageSelector type="button" />
          </Paper>
        </Box>
      )}
    </Container>
  );
}

export default LoginPage;
